<template>
  <el-dialog :title="isEdit?'编辑岗位':'添加岗位'"
             :visible.sync="visible"
             @open="init"
             @close="doClose"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="500px">
    <el-form class="widget-form" :model="post" label-width="120px" size="medium" ref="postFm">
      <el-form-item prop="name" label="岗位名称" :rules="[{ required: true, message: '请输入岗位名称', trigger: 'blur' }]">
        <el-input type="text" v-model="post.name" placeholder="请输入岗位名称"></el-input>
      </el-form-item>
      <el-form-item label="分类" prop="type" :rules="[{ required: true, message: '请选择分类', trigger: 'blur' }]">
        <el-radio-group v-model="post.type">
          <el-radio :label="1">通用岗位</el-radio>
          <el-radio :label="2">公司岗位</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="行业" prop="categoryId" v-if="post.type==1" :rules="[{ required: true, message: '请选择行业', trigger: 'blur' }]">
        <el-select multiple-limit="5" collapse-tags v-model="post.categoryId" placeholder="请选择行业">
          <el-option
            v-for="item in cateList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代理公司" prop="companyId" v-if="post.type==2" :rules="[{ required: true, message: '请选择代理公司', trigger: 'blur' }]">
        <el-select v-model="post.companyId" placeholder="请选择代理公司">
          <el-option
            v-for="item in companyList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属客户" prop="customerId" v-if="post.type==2" :rules="[{ required: true, message: '请选择所属客户', trigger: 'blur' }]">
        <el-select v-model="post.customerId" placeholder="请选择所属客户">
          <el-option
            v-for="item in customerList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="questions" v-for="question in questions" :key="question.questionId" :label="question.name">
        <el-input v-if="question.type === 0" type="text" v-model="question.answer" :placeholder="question.name"></el-input>
        <el-select v-else-if="question.type === 1" v-model="question.answer" :placeholder="question.name">
          <el-option
            v-for="item in question.options"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="introduce" label="备注:">
        <el-input type="textarea" v-model="post.remark" placeholder="请输入岗位备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="doClose" size="small"><i class="fa fa-close"></i> 关闭</el-button>
      <el-button type="primary" @click="submit()" size="small"><i class="fa fa-save"></i> 确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { get, save, update } from "@/api/rep/post";
import { fetchAll } from "@/api/rep/category";
import { fetchList as findCustomer } from "@/api/enterprise/customer";
import { fetchList as fetchCompany } from "@/api/enterprise/enterprise";
import { fetchList } from "@/api/manage/questions";

export default {
  watch: {
    "post.companyId": {
      handler(newType, oldType) {
        this.findCustomer(newType);
      }
    }
  },
  computed: {
    ...mapGetters(["user", "company"]),
    isEdit() {
      return this.postId;
    }
  },
  props: {
    visible: false,
    postId: null
  },
  data: function() {
    return {
      post: {
        contents: {}
      },
      questions: [
        { "name": "专业", answer: "", type: 0 },
        { "name": "学历", questionId: 5493, options: [], answer: 100, type: 1 },
        { "name": "参加工作年限", questionId: 5494, options: [], answer: 100, type: 1 },
        { "name": "专业工作年限", questionId: 5495, options: [], answer: 100, type: 1 },
        { "name": "专业知识的评估", questionId: 5496, options: [], answer: 100, type: 1 },
        { "name": "专业技能的评估", questionId: 5497, options: [], answer: 100, type: 1 }
      ],
      cateList: [],
      questionList: [],
      profession: [],
      customerList: [],
      companyList: [],
      contents: {}
    };
  },
  methods: {
    init() {
      if (this.postId) {
        this.getPost();
      } else {
        this.post = { type: 1 },
          this.profession = [],
          this.questions = [
            { "name": "专业", answer: "", type: 0 },
            { "name": "学历", questionId: 5493, options: [], answer: "", type: 1 },
            { "name": "参加工作年限", questionId: 5494, options: [], answer: "", type: 1 },
            { "name": "专业工作年限", questionId: 5495, options: [], answer: "", type: 1 },
            { "name": "专业知识的评估", questionId: 5496, options: [], answer: "", type: 1 },
            { "name": "专业技能的评估", questionId: 5497, options: [], answer: "", type: 1 }
          ];
      }
      this.getCategoryList();
      this.getQuestion();
      this.findCompany();
    },
    findCustomer(companyId) {
      findCustomer(companyId, { pageSize: 1000 }).then(res => {
        this.customerList = res.data.result.records;
      });
    },
    findCompany() {
      fetchCompany().then(res => {
        this.companyList = res.data.result;
      });
    },
    checkType() {
      if (this.post.type == 1) {
        this.post.customerId = null;
        this.post.customerName = null;
      } else {
        this.post.categoryId = null;
        this.post.categoryName = null;
      }
    },
    getPost() {
      get(this.postId).then(res => {
        this.post = res.data.result;
        if (!this.post.contents) {
          this.questions = [
            { "name": "专业", answer: "", type: 0 },
            { "name": "学历", questionId: 5493, options: [], answer: "", type: 1 },
            { "name": "参加工作年限", questionId: 5494, options: [], answer: "", type: 1 },
            { "name": "专业工作年限", questionId: 5495, options: [], answer: "", type: 1 },
            { "name": "专业知识的评估", questionId: 5496, options: [], answer: "", type: 1 },
            { "name": "专业技能的评估", questionId: 5497, options: [], answer: "", type: 1 }
          ];
        } else {
          this.questions = JSON.parse(this.post.contents);
        }
      });
    },
    getCategoryList() {
      fetchAll().then(resp => {
        this.cateList = resp.data.result;
      });
    },
    getQuestion() {
      fetchList(1213).then(res => {
        this.questionList = res.data.result;
        this.questionList.forEach(x => {
          this.questions.forEach(v => {
            if (v.questionId === x.id) {
              v.options = x.optionList;
            }
          });
        });
      });

    },
    doClose() {
      this.$emit("done", false);
    },
    submit() {
      this.$refs["postFm"].validate(valid => {
        if (valid) {
          this.checkType();
          this.post.contents = JSON.stringify(this.questions);
          if (this.post.type == 1) {
            this.cateList.forEach(o => {
              if (o.id === this.post.categoryId) {
                this.post.categoryName = o.name
              }
            })
          } else {
            this.companyList.forEach(o => {
              if (o.id === this.post.companyId) {
                this.post.companyName = o.name;
              }
            });
            this.customerList.forEach(o => {
              if (o.id === this.post.customerId) {
                this.post.customerName = o.name;
              }
            });
          }
          if (this.postId) {
            update(this.post).then(res => {
              this.$message.success("保存成功");
              this.$emit("done", true);
            });
          } else {
            save(this.post).then(res => {
              this.$message.success("保存成功");
              this.$emit("done", true);
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.sign {
  font-weight: bold;

  &:before {
    content: ' ';
    border-right: 4px solid #4381e6;
    margin-right: 8px;
  }
}
</style>
